
// require('@fortawesome/fontawesome-free');
require('pc-bootstrap4-datetimepicker');

$(function() {

    // Search Filters Datepicker
    // Using font-awesome 5 icons
    $.extend(true, $.fn.datetimepicker.defaults, {
        icons: {
            time: 'fa fa-clock',
            date: 'fa fa-calendar',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down',
            previous: 'fa fa-chevron-left',
            next: 'fa fa-chevron-right',
            today: 'fa fa-calendar-check',
            clear: 'fa fa-calendar-times',
            close: 'fa fa-times-circle'
        }
    });
    $('.datepicker-start').datetimepicker({
        format: 'DD/MM/YYYY',
        showTodayButton: true,
        showClear: true,
    });
    $('.datepicker-end').datetimepicker({
        format: 'DD/MM/YYYY',
        showTodayButton: true,
        showClear: true,
        useCurrent: false //Important! See issue #1075
    });

    $('.datepicker-start').on("dp.change", function(e) {
        $('.datepicker-end').data('DateTimePicker').minDate(e.date);
    });
    $('.datepicker-end').on("dp.change", function(e) {
        $('.datepicker-start').data('DateTimePicker').maxDate(e.date);
    });

    $('.reset-filter').on('click', function(e) {
        e.preventDefault();
        $(this).closest('form').find('input[type=text]').val('');
    });

    // download statement loading state
    $('.download-statement').on('click', function() {
        // $(this).addClass('disabled').text('loading')
        $(this).attr('disabled', true).addClass('disabled').html('<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span> Downloading...');
        // $(this).addClass('disabled').html('<i class="material-icons md-18 ml-1 fa-spin">refresh</i> Downloading');

        setCookie('downloadStarted', 0, 100); //Expiration could be anything... As long as we reset the value
        setTimeout(checkDownloadCookie, 1000); //Initiate the loop to check the cookie.
    });

    var downloadTimeout;
    var checkDownloadCookie = function() {
        if (getCookie("downloadStarted") == 1) {
            setCookie("downloadStarted", "false", 100); //Expiration could be anything... As long as we reset the value

            $('.download-statement').attr('disabled', false).removeClass('disabled').html('<i class="material-icons md-18 mr-2">picture_as_pdf</i> View Statement');

        } else {
            downloadTimeout = setTimeout(checkDownloadCookie, 1000); //Re-run this function in 1 second.
        }
    };

});




var setCookie = function(name, value, expiry) {
    var exdate = new Date();
    exdate.setTime(exdate.getTime() + expiry * 1000);
    var c_value = escape(value) + ((expiry == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = name + "=" + c_value + '; path=/';
};

var getCookie = function(name) {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == name) {
            return y ? decodeURI(unescape(y.replace(/\+/g, ' '))) : y; //;//unescape(decodeURI(y));
        }
    }
};


//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {


}